export default __webpack_public_path__ + "static/media/Helm of the Vanguard.3026e690.jpg";